import { SearchField as AmplifyUiSearchField } from "@aws-amplify/ui-react"
import { useState } from "react"
import { useSearchParams } from "react-router-dom"

interface SearchFieldProps {
  whiteBackground?: boolean
}
export default function SearchField({ whiteBackground }: SearchFieldProps) {
  const [searchParams, setSearchParams] = useSearchParams()
  const [value, setValue] = useState<string | undefined>(
    searchParams.get("filter") ?? undefined
  )

  const onChange: React.ChangeEventHandler<HTMLInputElement> = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const filter = event.target.value
    setValue(filter)
    if (filter) {
      setSearchParams({ filter }, { replace: true })
    } else {
      setSearchParams({}, { replace: true })
    }
  }

  const onClear = () => {
    setValue("")
    setSearchParams({}, { replace: true })
  }

  return (
    <AmplifyUiSearchField
      backgroundColor={whiteBackground ? "white" : undefined}
      label="Suche"
      placeholder="Suche..."
      onChange={onChange}
      onClear={onClear}
      value={value}
    />
  )
}
